import React, { useState } from 'react';
import * as Styles from './Header.styles';

export const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigateTo = (path: string) => {
    window.location.href = path;
    setMenuOpen(false); // Close the menu after navigation
  };

  return (
    <Styles.HeaderContainer>
      <Styles.Logo onClick={() => navigateTo('/')}>LRPG</Styles.Logo>
      <Styles.MenuButton onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </Styles.MenuButton>
      <Styles.NavBar className={menuOpen ? 'open' : ''}>
        <Styles.NavButton onClick={() => navigateTo('/projects')}>Projects</Styles.NavButton>
        <Styles.NavButton onClick={() => navigateTo('/events')}>Events</Styles.NavButton>
        <Styles.NavButton onClick={() => navigateTo('/membership-applications')}>Membership Applications</Styles.NavButton>
        <Styles.NavButton onClick={() => navigateTo('/board')}>Board</Styles.NavButton>
        <Styles.NavButton onClick={() => navigateTo('/about')}>About Us</Styles.NavButton>
      </Styles.NavBar>
    </Styles.HeaderContainer>
  );
};
